<script lang="ts" setup>
import userStore from '@/store/UserStore'

defineProps({
  productTitle: {
    type: String,
    default: ''
  },
  quantity: {
    type: Number,
    default: 1
  }
})
</script>

<template>
  <div
    :class="{
      'brand-va': userStore.brand === 'VAILLANT',
      'brand-sd': userStore.brand === 'SAUNIERDUVAL'
    }"
    class="cascade-badge badge"
  >
    <p>{{ $t('step_heat_pumps.badge_cascade_title') }}</p>
    <h3>{{ quantity }}x {{ productTitle }}</h3>
  </div>
</template>

<style lang="scss" scoped>
.cascade-badge {
  z-index: 2;
  text-align: center;
  display: block;
  left: rem-calc(-9);
  right: unset;
  top: rem-calc(40);

  p,
  h3 {
    color: white;
  }

  p {
    margin-bottom: 0;
    font-size: 0.9rem;
  }

  h3 {
    font-size: 1.35rem;
  }

  &.badge {
    padding: 1rem;
  }

  &.brand-va {
    @include themify($themes) {
      background: themed('primaryColor');
    }

    &:after {
      @include themify($themes) {
        border-top-color: $vaPrimaryDarkColor;
      }
    }
  }

  &.brand-sd {
    @include themify($themes) {
      background: themed('secondaryColor');
    }

    &:after {
      @include themify($themes) {
        border-top-color: $sdSecondaryDarkColor;
      }
    }
  }

  &:after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    bottom: rem-calc(-7);
    left: rem-calc(0);
    @include themify($themes) {
      border-top: rem-calc(7) solid themed('secondaryColorDark');
      border-left: rem-calc(9) solid transparent;
      border-right: 0;
    }
  }
}
</style>
